import { FC } from "react"
import { Drawer } from "@mui/material"
import { Icon, IconColor, IconProps } from "@/components/shared/Icon"
import { WearableCardProps } from "@/components/WearableCard"
import WearableCardMedium from "@/components/WearableCard/WearableCardMedium"
import "./index.scss"

const WearablesDrawer: FC<{
   icon?: IconProps["name"]
   title?: string
   data: WearableCardProps[]
   emptyMessage?: string
   show: boolean
   onHide: () => void
}> = ({ icon, title, show, data, emptyMessage, onHide }) => {
   return (
      <Drawer
         anchor="right"
         open={show}
         onClose={onHide}
      >
         <div className="wearables-drawer">
            <div className="wearables-drawer__header">
               <div className="wearables-drawer__title">
                  {icon && (
                     <Icon
                        name={icon}
                        size="24"
                        color={IconColor.HONOLULU_BLUE}
                     />
                  )}
                  <span>{title}</span>
               </div>
               <Icon
                  name="cross"
                  size="16"
                  color={IconColor.HONOLULU_BLUE}
                  onClick={onHide}
               />
            </div>
            <div className="wearables-drawer__content">
               {data.length === 0 && emptyMessage && (
                  <div className="wearables-drawer__empty">{emptyMessage}</div>
               )}
               {data.map((wearable) => (
                  <WearableCardMedium
                     key={`wearable-${wearable.wearableId}`}
                     {...wearable}
                  />
               ))}
            </div>
         </div>
      </Drawer>
   )
}

export default WearablesDrawer
